import React from 'react';
import { Colors } from '../../Constants/colors';
import { useLocation, useNavigate } from 'react-router-dom';

export interface HeaderNavigationProps {
  text: string;
  section: string;
}

interface Props {
  headerNavigation: HeaderNavigationProps[];
}

export const HeaderNavigation = ({ headerNavigation }: Props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const section = searchParams.get('section');
  const pathName = location.pathname;

  const onNavigationChange = (navigation: HeaderNavigationProps) => {
    const updatedSearchParams = new URLSearchParams();
    searchParams.forEach((value, key) => {
      if (key !== 'section') {
        updatedSearchParams.append(key, value);
      }
    });
    updatedSearchParams.set('section', navigation.section);
    const newSearchParamsString = updatedSearchParams.toString();
    const newUrl = `${pathName}${
      newSearchParamsString ? '?' + newSearchParamsString : ''
    }`;
    navigate(newUrl);
  };
  return (
    <div
      className="flex gap-8 pb-4 mt-8"
      style={{
        height: '30px',
        color: Colors.DarkGrey,
        borderBottom: `1px solid ${Colors.LightAshRose}`,
      }}
    >
      {headerNavigation.map((navigation: HeaderNavigationProps) => (
        <div
          className="pl-2 pr-2 text-sm"
          style={{
            borderBottom:
              section === navigation.section
                ? `2px solid ${Colors.AshRose}`
                : undefined,
            height: '30px',
            cursor: 'pointer',
          }}
          onClick={() => {
            onNavigationChange(navigation);
          }}
        >
          {navigation.text}
        </div>
      ))}
    </div>
  );
};
